const BarlineRow = () => (
  <div class="sequencer-barline-row" aria-hidden="true">
    <div class="sequencer-barline-row__line sequencer-barline-row__line--upper" />
    <div class="sequencer-barline-row__line sequencer-barline-row__line--lower" />
  </div>
);

export default BarlineRow;
